import styles from 'components/taUi/taLoaderBar/taLoaderBar.module.css';
import PropTypes from "prop-types";
import React from "react";

const TaLoaderBar = (props) => {
    const {percent} = props;
    return (
        <div className={styles.root}>
            <div className={styles.progress} style={{width: (percent || 1) + '%'}}/>
        </div>
    );
};

TaLoaderBar.percent = {
    name: PropTypes.number.isRequired,
};

export default TaLoaderBar;
